
import React, { useState } from 'react';
import './Questions.css';
import { FaUpload, FaDownload } from 'react-icons/fa';
import ViewQuestion from '../ViewQuestion/ViewQuestion';
import AddQuestion from '../AddQuestion/AddQuestion';
import { toast } from 'react-toastify';
import { uploadQuestions } from '../../../../api/questionApi';

const Questions = () => {
  const [fileName, setFileName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleAddQuestion = () => {
    setIsModalOpen(true);
  };

  const handleUploadFile = (event) => {
    const file = event.target.files[0];
    if (file) {
    
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                      file.type === 'application/vnd.ms-excel';
      
      if (!isExcel) {
        alert('Please upload only Excel files (.xlsx or .xls)');
        event.target.value = null; 
        setFileName('');
        setSelectedFile(null);
        return;
      }
      
      setFileName(file.name);
      setSelectedFile(file);
    }
  };

  const handleSubmitFile = async () => {
    if (!selectedFile) return;
    
    setIsLoading(true);
    try {
      await uploadQuestions(selectedFile);
      toast.success('File uploaded successfully!');
      setFileName('');
      setSelectedFile(null);
    } catch (error) {
      toast.error('Error uploading file. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadTemplate = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/assets/data/questiontemplate.xlsx`;
    link.download = 'questiontemplate.xlsx';
    link.click();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div className="questions-container">
        <div className="button-group">
          <button className="add-question-btn" onClick={handleAddQuestion}>
            Add Question
          </button>
          <div className="upload-section">
            {!selectedFile ? (
              <label className="upload-btn">
                <FaUpload /> Upload File
                <input 
                  type="file" 
                  onChange={handleUploadFile}
                  accept=".xlsx,.xls"
                />
              </label>
            ) : (
              <button 
                className="excel-template-upload-btn"
                onClick={handleSubmitFile}
                disabled={isLoading}
              >
                {isLoading ? 'Submitting...' : 'Submit'}
              </button>
            )}
            <button className="download-icon" onClick={handleDownloadTemplate}>
              <FaDownload />
            </button>
            {fileName && <p className="file-name">{fileName}</p>}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="question-modal">
          <div className="question-modal-content">
            <span className="question-close-btn" onClick={handleCloseModal}>
              &times;
            </span>
            <AddQuestion onClose={handleCloseModal} />
          </div>
        </div>
      )}

      <ViewQuestion />
    </div>
  );
};

export default Questions;